import { httpClient } from "./httpClient";
import dayjs from "dayjs";

const getAllLeaveBalanceByEmployeeId = (year) => {
  return httpClient.get(`/users/leave?year=${year}`);
};

const allLeaveType = () => {
  return httpClient.get(`/vendor/leave-type`);
};

const allLeaveEmployeeByManager = (search) => {
  return httpClient.get(
    `request/leave?start=${dayjs(search.start).format(
      "YYYY-MM-DD"
    )}&end=${dayjs(search.end).format("YYYY-MM-DD")}`
  );
};

const updateApproveLeaveEmployeeBy = (filter, formData) => {
  return httpClient.put(`request/leave/approve?filter=${filter}`, formData);
};

const withdrawLeaveEmployee = (filter, formData) => {
  if (filter) {
    return httpClient.put(`request/leave/withdraw?filter=${filter}`, formData);
  } else {
    return httpClient.put(`request/leave/withdraw`, formData);
  }
};

const getAllLeaveWithDrawBy = (filter, search) => {
  if (search) {
    return httpClient.get(
      `request/leave/withdraw?filter=${filter}&start=${dayjs(
        search.start
      ).format("YYYY-MM-DD")}&end=${dayjs(search.end).format("YYYY-MM-DD")}`
    );
  } else {
    return httpClient.get(`request/leave/withdraw?filter=${filter}`);
  }
};

const addLeaveType = (id, formData) => {
  return httpClient.post(`/company/${id}/leave-type`, formData);
};

const addLeaveEmployees = (formData) => {
  return httpClient.post(`/employee/leave`, formData);
};

const uploadFileLeaveType = (formData) => {
  return httpClient.post(`/leave`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const getAllLeaveEmployeesBy = (filter, search) => {
  return httpClient.get(
    `leave?filter=${filter}&start=${dayjs(search.start).format(
      "YYYY-MM-DD"
    )}&end=${dayjs(search.end).format("YYYY-MM-DD")}`
  );
};

const allLeaveTypeByCompany = () => {
  return httpClient.get(`company/leave-type`);
};

const getPatternForLeave = (searchDate) => {
  return httpClient.get(`/pattern/leave`, {
    params: {
      start: dayjs(searchDate.startDate).format("YYYY-MM-DD"),
      end: dayjs(searchDate.endDate).format("YYYY-MM-DD"),
      idEmp: searchDate.idEmp,
    },
  });
};

const getAllVendorCompanyLeaveType = (data) => {
  return httpClient.get(`/leave-type`, {
    params: data,
  });
};

const uploadFileVendorCompanyLeaveType = (formData) => {
  return httpClient.post(`/leave/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const addVendorCompanyLeaveType = (formData) => {
  return httpClient.post(`/leave/add`, formData);
};

const getLeaveById = (id) => {
  return httpClient.get(`/leave/${id}`);
};

const editVendorCompanyLeaveType = (formData) => {
  return httpClient.put(`/leave/edit`, formData);
};

const deleteVendorCompanyLeaveType = (id) => {
  return httpClient.post(`/leave/delete/${id}`);
};

const getLeaveSetting = () => {
  return httpClient.get(`leave-setting`);
};

const getLeaveAvailable = (query) => {
  return httpClient.get(`leave/leave-available`, { params: query });
}

const withdrawEmployeeLeaveRequest = (idLeave) => {
  return httpClient.post(`/leave/request/${idLeave}/withdraw`)
}

const getLeaveRoundList = (query) => {
  return httpClient.get(`leave/leave-round-list`, { params: query });
}

const addLeaveQuota = (formData) => {
  return httpClient.post(`/leave-quota`, formData);
}

const updateLeaveQuota = (idLeaveQuota, formData) => {
  return httpClient.put(`/leave-quota/${idLeaveQuota}`, formData);
}

const createLeaveGroup = (formData) => {
  return httpClient.post(`/leave-group`, formData);
}

const updateLeaveGroup = (formData) => {
  return httpClient.put(`/leave-group`, formData);
}

const deleteLeaveGroup = (idLeaveGroup) => {
  return httpClient.delete(`/leave-group/${idLeaveGroup}`);
}

const getAllLeaveGroupByVendorId = (idVendor, query) => {
  return httpClient.get(`/vendors/${idVendor}/leave-group`, { params: query });
}

const getManagerPendingRequestLeave = (query) => {
  return httpClient.get(`manager/leave/pending-list`, { params: query });
}

const approveRequestLeaveByManager = (formData) => {
  return httpClient.post(`manager/leave/approve`, formData);
}

const getCompanyPendingRequestLeave = (idCompany, query) => {
  return httpClient.get(`/company/${idCompany}/leave/pending-list`, { params: query });
}

const approveRequestLeaveByAdmin = (formData) => {
  return httpClient.post(`admin/leave/approve`, formData);
}

const createLeavePolicyVersion = (idLeaveGroup, formData) => {
  return httpClient.post(`/leave-groups/${idLeaveGroup}/versions`, formData);
}

const getLeavePolicyVersionsByLeaveGroupId = (idLeaveGroup) => {
  return httpClient.get(`/leave-groups/${idLeaveGroup}/versions`);
}

export default {
  getAllLeaveBalanceByEmployeeId,
  allLeaveEmployeeByManager,
  updateApproveLeaveEmployeeBy,
  withdrawLeaveEmployee,
  getAllLeaveWithDrawBy,
  allLeaveType,
  addLeaveType,
  addLeaveEmployees,
  uploadFileLeaveType,
  getAllLeaveEmployeesBy,
  allLeaveTypeByCompany,
  getPatternForLeave,
  getAllVendorCompanyLeaveType,
  uploadFileVendorCompanyLeaveType,
  addVendorCompanyLeaveType,
  getLeaveById,
  editVendorCompanyLeaveType,
  deleteVendorCompanyLeaveType,
  getLeaveSetting,
  getLeaveAvailable,
  withdrawEmployeeLeaveRequest,
  getLeaveRoundList,
  addLeaveQuota,
  updateLeaveQuota,
  createLeaveGroup,
  updateLeaveGroup,
  deleteLeaveGroup,
  getAllLeaveGroupByVendorId,
  getManagerPendingRequestLeave,
  approveRequestLeaveByManager,
  getCompanyPendingRequestLeave,
  approveRequestLeaveByAdmin,
  createLeavePolicyVersion,
  getLeavePolicyVersionsByLeaveGroupId,
};
